module.exports = __webpack_public_path__ + "static/media/articulatione3b8cd01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/articulation.svg
// module id = 1315
// module chunks = 0